import { Beaufort } from "src/app/constants/standard/beaufort.standard";
import { CloudStandard } from "src/app/constants/standard/cloud.standard";
import { FlightConfigurationDto } from "../flightConfiguration/flightConfiguration.dto";
import { DirectionCode } from "./direction.code";
import { FlightStatusCode } from "./weather/flightStatus.code";
import { WeatherInfo } from "./weather/weatherInfo.dto";

export class WeatherListItemDto {
    public timeTag!: string;
    public data!: WeatherInfo;

    public convertWindDirectionToCode(): DirectionCode {
        switch (this.data?.windDirection) {
            case "N":
                return DirectionCode.N;
            case "NE":
                return DirectionCode.NE;
            case "E":
                return DirectionCode.E;
            case "SE":
                return DirectionCode.SE;
            case "S":
                return DirectionCode.S;
            case "SW":
                return DirectionCode.SW;
            case "W":
                return DirectionCode.W;
            case "NW":
                return DirectionCode.NW;
        }

        return DirectionCode.N;
    }

    public getDirectionStyle(): any {
        let degree = 90;
        switch (this.data.windDirection) {
            case "N":
                degree = 90;
                break;
            case "NE":
                degree = 135;
                break;
            case "E":
                degree = 180;
                break;
            case "SE":
                degree = 225;
                break;
            case "S":
                degree = 270;
                break;
            case "SW":
                degree = 315;
                break;
            case "W":
                degree = 360;
                break;
            case "NW":
                degree = 45;
                break;
        }

        return {"transform" : "rotate(" + degree + "deg)"};
    }

    public getHeightPercentStyle(maxWindSpeed: number): any {
        let percent:number
             = this.data.windSpeed / maxWindSpeed * 45;

        return {'height' : percent + "%"};
    }

    public isPossibleFlight(flightConfigurationDto: FlightConfigurationDto, isContainedGust: boolean): FlightStatusCode {
        let result: FlightStatusCode = FlightStatusCode.GOOD;

        if (this.getWindStatus(flightConfigurationDto) != FlightStatusCode.GOOD) {
            result = this.getWindStatus(flightConfigurationDto);
            
            if (result == FlightStatusCode.DANGER) {
                return result;
            }
        }

        if (isContainedGust == true && this.getWindGustStatus(flightConfigurationDto, isContainedGust) != FlightStatusCode.GOOD) {
            result = this.getWindGustStatus(flightConfigurationDto, isContainedGust);

            if (result == FlightStatusCode.DANGER) {
                return result;
            }
        }

        if (this.data.temperature > flightConfigurationDto.maximumTemperature
            || this.data.temperature < flightConfigurationDto.minimumTemperature) {
                return FlightStatusCode.DANGER;
        }

        if (flightConfigurationDto.maximumHumidity != null) {
            if (this.data.humidity > flightConfigurationDto.maximumHumidity || this.data.humidity < flightConfigurationDto.minimumHumidity) {
                return FlightStatusCode.DANGER;
            }
        }

        if (this.data.precipitation > flightConfigurationDto.precipitation) {
            return FlightStatusCode.DANGER;
        }

        if (this.getCloudCoverStatus(flightConfigurationDto) != FlightStatusCode.GOOD) {
            result = this.getCloudCoverStatus(flightConfigurationDto);

            if (result == FlightStatusCode.DANGER) {
                return result;
            }
        }

        return result;
    }

    public isPossibleFlightWithSatellite(flightConfigurationDto: FlightConfigurationDto, satelliteCount: number, isContainedGust: boolean): FlightStatusCode {
        let status: FlightStatusCode = this.isPossibleFlight(flightConfigurationDto, isContainedGust)
        
        if (status != FlightStatusCode.GOOD) {
            return status;
        }

        if (flightConfigurationDto.satelliteCount > satelliteCount) {
            return FlightStatusCode.DANGER;
        }

        return FlightStatusCode.GOOD;
    }

    public getWindStatus(flightConfigurationDto: FlightConfigurationDto): FlightStatusCode {
        if (this.data.windSpeed > flightConfigurationDto.windResistance) {
            return FlightStatusCode.DANGER;
        }

        if (this.data.windSpeed > Beaufort.LEVEL3) {
            return FlightStatusCode.CARE;
        }

        return FlightStatusCode.GOOD;
    }

    public getWindGustStatus(flightConfigurationDto: FlightConfigurationDto, isContainedGust: boolean): FlightStatusCode {
        if (!isContainedGust) {
            return FlightStatusCode.GOOD;
        }

        if (this.data.windGust > flightConfigurationDto.windResistance) {
            return FlightStatusCode.DANGER;
        }

        if (this.data.windGust > Beaufort.LEVEL3) {
            return FlightStatusCode.CARE;
        }

        return FlightStatusCode.GOOD;
    }

    public getCloudCoverStatus(flightConfigurationDto: FlightConfigurationDto): FlightStatusCode {
        if (this.data.totalCloudCover > flightConfigurationDto.cloudCover) {
            return FlightStatusCode.DANGER;
        }

        if (this.data.totalCloudCover > CloudStandard.LITTLE_CLOUD) {
            return FlightStatusCode.CARE;
        }

        return FlightStatusCode.GOOD;
    }
}